import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { User, UserAPI } from '../models/user';
import { FormGroup } from '@angular/forms';

type RetourAPI = {
  data: {
    user: UserAPI;
    token: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);
  user: User | null = null;
  token: string | null = null;

  getToken(): string | null {
    return this.token;
  }
  getUser(): User | null {
    return this.user;
  }

  getHeaders(token: string | undefined = undefined): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + (token ?? this.getToken()),
    });
  }

  login(loginForm: FormGroup): Observable<User> {
    return this.http
      .post<RetourAPI>(`${environment.api.gateway}login`, {
        username: loginForm.value.username,
        password: loginForm.value.password,
      })
      .pipe(
        tap((RetourAPI) => (this.token = RetourAPI.data.token)),
        tap((RetourAPI) => {
          if (this.token) {
            localStorage.setItem('token', this.token);
          }
        }),
        map((retourAPI: RetourAPI) => User.factory(retourAPI.data.user)),
        tap((user: User) => {
          this.user = user;
        })
      );
  }

  logout(): Observable<any> {
    const headers = this.getHeaders();

    return this.http.delete<RetourAPI>(`${environment.api.gateway}logout`, {
      headers,
    });
  }

  verificationConnexion(token: string): Observable<User> {
    const headers = this.getHeaders(token);

    return this.http
      .get<UserAPI>(`${environment.api.gateway}profil`, {
        headers,
      })
      .pipe(
        map((userAPI: UserAPI) => User.factory(userAPI)),
        tap((user: User) => {
          this.token = token;
          localStorage.setItem('token', this.token);
          this.user = user;
        }),
        catchError((error) => {
          if (error.status === 401) {
            // Supprimer le token du localStorage si retour 401
            // localStorage.removeItem('token');
            this.token = null;
            this.user = null;
          }
          throw error;
        })
      );
  }
}
